import React from 'react';

const SkeletonLoader = () => (
    <div className='flex flex-col gap-3 text-xs lg:text-sm animate-pulse'>
        <div className='flex flex-col justify-start gap-4 lg:gap-10'>
            <div className='h-8 bg-gray-200 rounded w-48'></div>
            <div className='h-4 bg-gray-200 rounded w-36 -mt-4 lg:-mt-10'></div>
        </div>
        <div className="bg-gray-200 h-[5rem] rounded-md"></div>
        <div className='flex gap-2'>
            <div className='h-16 w-16 bg-gray-200 rounded-full mt-4'></div>
            <div className='my-4 mx-2 md:mx-4'>
                <div className='h-6 bg-gray-200 rounded w-40'></div>
                <div className='h-4 bg-gray-200 rounded w-32 mt-2'></div>
            </div>
        </div>
        <div className='flex flex-row gap-2 items-center mt-2'>
            <div className='h-[15px] bg-gray-200 w-[5px]'></div>
            <div className='h-6 bg-gray-200 rounded w-48'></div>
        </div>
        <div>
            <div className='py-1 lg:py-2 grid sm:grid-cols-2 gap-4'>
                {[...Array(8)].map((_, index) => (
                    <span key={index}>
                        <div className='h-4 bg-gray-200 rounded w-32 mb-2'></div>
                        <div className='w-full md:w-[80%] h-10 bg-gray-200 rounded-md'></div>
                    </span>
                ))}
            </div>
        </div>
        <div className='flex flex-row gap-2 items-center mt-2'>
            <div className='h-[15px] bg-gray-200 w-[5px]'></div>
            <div className='h-6 bg-gray-200 rounded w-32'></div>
        </div>
        <div className='py-4 lg:py-8 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-y-8'>
            {[...Array(2)].map((_, index) => (
                <span key={index}>
                    <div className='h-4 bg-gray-200 rounded w-28 mb-2'></div>
                    <div className='w-full md:w-[80%] h-10 bg-gray-200 rounded-md'></div>
                </span>
            ))}
        </div>
    </div>
);

export default SkeletonLoader; 